// extracted by mini-css-extract-plugin
export default {"finishButton":"finishButton_finishButton__uFVJx","label":"finishButton_label__+spG9"};